<template>
    <el-container class="main-container" style="height: 100%">
        <el-header class="header">
            <Header ref="header" />
        </el-header>
        <el-container style="height: calc(100vh - 60px); margin: 0" ref="container">
            <el-aside class="aside aside-menu menu">
                <el-scrollbar style="height:100%">
                    <SideMenu/>
                </el-scrollbar>
            </el-aside>
            <el-main ref="mainContiner" style="height: 100%;">
                <el-scrollbar class="main-scroll" :style="{height: scrollHeight + 'px', width: '100%'}">
                    <div class="tabs">
                        <el-tabs v-model="currentTabPath" type="card" @tab-remove="removeTab" @tab-click="clickTab" @contextmenu.prevent.native="openContextMenu($event)">
                            <el-tab-pane :key="item.path + index" v-for="(item, index) in tabOptions" :label="item.title" :name="item.path" :closable="item.closable"></el-tab-pane>
                        </el-tabs>
                    </div>
                    <div class="content-wrap" :style="{height: (scrollHeight - 38) + 'px'}">
                        <router-view :key="routerKey"></router-view>
                    </div>
                </el-scrollbar>
            </el-main>
        </el-container>
        <div v-show="contextMenuVisible">
            <ul
                    :style="{left: tabsStyle.left+'px',top: tabsStyle.top+'px'}"
                    class="contextmenu"
            >
                <li @click="curTabReload">重新加载</li>
                <li @click="closeAllTabs">关闭所有</li>
                <li @click="closeOtherTabs('left')" v-if="isDisabledCloseLeftBtnFlag">关闭左边</li>
                <li @click="closeOtherTabs('right')" v-if="isDisabledCloseRightBtnFlag">关闭右边</li>
                <li @click="closeOtherTabs('other')">关闭其他</li>
            </ul>
        </div>
    </el-container>
</template>
<script>
import Header from '@/views/managementSystem/systemLayout/header'
import SideMenu from '@/views/managementSystem/systemLayout/sideMenu'
export default {
  name: 'mainHome',
  components: {
    Header,
    SideMenu
  },
  data() {
    return {
      containerHeight: 0,
      scrollHeight: 0, // 滚动区域高度
      contextMenuVisible: false, // 是否显示右键tab
      tabsStyle: {
        top: 0,
        left: 0
      },
      isDisabledCloseLeftBtnFlag: false,
      isDisabledCloseRightBtnFlag: false,
      currentTabPath: this.$route.path,
      routerKey: null
    }
  },
  computed: {
    tabOptions () {
      return this.$store.state.tabOptions
    }
  },
  watch: {
    $route(to) {
      if (to.path !== '/home') {
        this.currentTabPath = to.path
        this.addTab(to)
      };
      this.routerKey = new Date().getTime()
    },
    contextMenuVisible(value) {
      if (this.contextMenuVisible) {
        document.body.addEventListener('click', this.closeContextMenu)
      } else {
        document.body.removeEventListener('click', this.closeContextMenu)
      }
    }
  },
  methods: {
    // 添加tab
    addTab (data) {
      const flag = this.tabOptions.findIndex(item => item.path === data.path)
      if (flag === -1) {
        this.$store.commit('addTab', {
          path: data.path,
          name: data.name,
          title: !!data.params && data.params.type ? data.meta.title + data.params.type : data.meta.title,
          closable: data.meta.closable
        })
      };
    },
    // 删除tab项
    removeTab (name) {
      if (this.tabOptions.length === 1) {
        this.$utils.info('已经是最后一个tab项，不能删除....')
        return
      }
      this.$store.commit('closeTab', name)
      let path = ''
      if (this.tabOptions.length === 0) {
        path = '/home'
      } else {
        if (name === this.$route.path) {
          path = this.tabOptions[this.tabOptions.length - 1].path
        } else {
          path = this.$route.path
          return
        }
      };
      this.$router.push({
        path
      })
    },
    // 点击tab
    clickTab (data) {
      this.$router.replace({path: data.name})
    },
    // 打开右键菜单
    openContextMenu (e) {
      e.preventDefault() // 防止默认菜单弹出
      const obj = e.srcElement ? e.srcElement : e.target
      if (obj.id) {
        const currentContextTabId = obj.id.split('-')[1]
        let curIndex = 0
        for (curIndex = 0; curIndex < this.tabOptions.length; ++curIndex) {
          if (this.tabOptions[curIndex].path === currentContextTabId) {
            break
          }
        }
        if (curIndex === 0 && this.tabOptions.length === 1) {
          this.isDisabledCloseLeftBtnFlag = false
          this.isDisabledCloseRightBtnFlag = false
        } else if (curIndex <= 0) {
          this.isDisabledCloseLeftBtnFlag = false
          this.isDisabledCloseRightBtnFlag = true
        } else if (curIndex >= this.tabOptions.length - 1) {
          this.isDisabledCloseLeftBtnFlag = true
          this.isDisabledCloseRightBtnFlag = false
        } else {
          this.isDisabledCloseLeftBtnFlag = true
          this.isDisabledCloseRightBtnFlag = true
        }
        this.contextMenuVisible = true
        this.$store.commit('saveCurContextTabId', currentContextTabId)
        this.tabsStyle.left = e.clientX
        this.tabsStyle.top = e.clientY + 10
      }
    },
    // 关闭右键tabs事件
    closeContextMenu() {
      this.contextMenuVisible = false
    },
    // 重新加载
    curTabReload () {
      this.routerKey = new Date().getTime()
      this.closeContextMenu()
    },
    // 删除所有tabs
    closeAllTabs() {
      this.$store.commit('closeAllTabs')
      this.contextMenuVisible = false
      this.closeContextMenu()
    },
    // 关闭指定的tab, left-左边，right-右边，other-其他
    closeOtherTabs (type) {
      this.$store.commit('closeOtherTabs', type)
      this.closeContextMenu()
    }
  },
  created() {
    this.addTab(this.$route)
  },
  mounted () {
    this.$nextTick(function () {
      this.scrollHeight = this.$refs.mainContiner.$el.offsetHeight - 18
    })
  }
}
</script>
<style lang="less">
    .main-container {
        .aside-menu {
            width: 98px !important;
            height: 100%;
            background: #283B5C;
            box-sizing: border-box;
        }
        .header {
            padding: 0px;
        }
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }
        .el-main {
            background: #e8edf4;
            padding: 6px 10px 10px;
            .tabs {
                margin-bottom: 6px;
                .el-tabs__header {
                    border: none;
                    margin: 0;
                    .el-tabs__nav-prev .el-icon-arrow-left,.el-tabs__nav-next .el-icon-arrow-right{
                        font-size: 18px;
                        position: relative;
                        top: -1px;
                    }
                    .el-tabs__nav-prev, .el-tabs__nav-next {
                        line-height: 32px;
                    }
                    .el-tabs__nav-scroll {
                        font-size: 14px;
                        .el-tabs__nav {
                            border: none;
                            .el-tabs__item {
                                height: 32px;
                                line-height: 32px;
                                margin-right: 6px;
                                padding: 0px 15px;
                                color: #666666;
                                font-weight: normal;
                                text-align: center;
                                background: #ffffff;
                                border-radius: 4px;
                                &.is-active {
                                    color: #2789EE;
                                }
                                .el-icon-close {
                                    width: 14px;
                                }
                            }
                        }
                    }
                }
            }
            .content-wrap {
                background: #fff;
                border-radius: 4px;
            }
        }
    }
</style>
